const typographyModalDocCompany = {
  true: 'Register New Document',
  false: 'Edit Document'
};

export default typographyModalDocCompany;
